import React from "react";

import theme from "theme";

import Box from "components/Box";

export interface IStickyMenu {
  sx?: object;
  top?: string;
  children?: React.ReactNode;
}

const StickyMenu = ({ children, top = theme.spacing(6), sx }: IStickyMenu) => (
  <Box sx={{ position: "sticky", top, ...sx }} data-testid="side-menu">
    {children}
  </Box>
);

export default StickyMenu;
